var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mostraBloco
    ? _c(
        "div",
        { staticClass: "acoes-modulo", class: _vm.classeDaDensidade },
        [
          _vm.temAviso
            ? _c(
                "div",
                {
                  staticClass: "acoes-modulo__aviso",
                  attrs: { "data-teste": "acoes-modulo-aviso" }
                },
                [
                  _c("icon-svg", {
                    staticClass: "flex-shrink-0",
                    attrs: {
                      name: "warning-status",
                      size: 14,
                      color: "var(--warning-text-strong)"
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "acoes-modulo__aviso-texto ia-texto-auxiliar"
                    },
                    [_vm._v(_vm._s(_vm.aviso))]
                  ),
                  _vm.avisoAcao
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "acoes-modulo__aviso-acao ia-texto-auxiliar az-ds-hyperlink",
                          attrs: {
                            type: "button",
                            "data-teste": "acoes-modulo-aviso-acao"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("aviso-acao")
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.avisoAcao) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.ehCarrossel
            ? _c("div", { staticClass: "acoes-modulo__cabecalho" }, [
                _c(
                  "span",
                  { staticClass: "acoes-modulo__titulo-secao ia-texto-corpo" },
                  [_vm._v(_vm._s(_vm.tituloDaSecao))]
                ),
                _vm.podeRolar
                  ? _c("span", { staticClass: "acoes-modulo__setas" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "acoes-modulo__seta acoes-modulo__seta--anterior",
                          attrs: {
                            type: "button",
                            disabled: _vm.noComeco,
                            "aria-label": "Ver ações anteriores"
                          },
                          on: {
                            click: function($event) {
                              return _vm.rolar(-1)
                            }
                          }
                        },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: "arrow-down-light",
                              size: 16,
                              color: "currentColor"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "button",
                        {
                          staticClass:
                            "acoes-modulo__seta acoes-modulo__seta--proxima",
                          attrs: {
                            type: "button",
                            disabled: _vm.noFim,
                            "aria-label": "Ver mais ações"
                          },
                          on: {
                            click: function($event) {
                              return _vm.rolar(1)
                            }
                          }
                        },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: "arrow-down-light",
                              size: 16,
                              color: "currentColor"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          !_vm.ehCarrossel && _vm.modulos.length > 1
            ? _c("div", { staticClass: "acoes-modulo__abas-wrapper" }, [
                _vm.podeRolarAbas
                  ? _c(
                      "button",
                      {
                        ref: "setaAbaAnterior",
                        staticClass:
                          "acoes-modulo__seta acoes-modulo__seta--anterior acoes-modulo__seta--abas",
                        attrs: {
                          type: "button",
                          disabled: _vm.noComecoAbas,
                          "aria-label": "Ver módulos anteriores"
                        },
                        on: {
                          click: function($event) {
                            return _vm.rolarAbas(-1)
                          }
                        }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "arrow-down-light",
                            size: 13,
                            color: "currentColor"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    ref: "trilhoAbas",
                    staticClass: "acoes-modulo__abas",
                    class: {
                      "acoes-modulo__abas--arrastando": _vm.arrastandoAbas
                    },
                    on: {
                      scroll: _vm.aoRolarAbas,
                      mousedown: _vm.iniciarArrastoAbas,
                      mousemove: _vm.moverArrastoAbas,
                      mouseup: _vm.finalizarArrastoAbas,
                      mouseleave: _vm.finalizarArrastoAbas
                    }
                  },
                  _vm._l(_vm.abas, function(aba, indice) {
                    return _c(
                      "button",
                      {
                        key: aba.moduleKey,
                        ref: "botaoDaAba",
                        refInFor: true,
                        staticClass: "acoes-modulo__aba ia-texto-auxiliar",
                        class: { "acoes-modulo__aba--ativa": aba.ativa },
                        attrs: {
                          type: "button",
                          "aria-pressed": aba.ativa ? "true" : "false",
                          "data-texto": aba.rotulo
                        },
                        on: {
                          click: function($event) {
                            return _vm.selecionarAba(indice)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "acoes-modulo__aba-rotulo" },
                          [_vm._v(_vm._s(aba.rotulo))]
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm.podeRolarAbas
                  ? _c(
                      "button",
                      {
                        ref: "setaAbaProxima",
                        staticClass:
                          "acoes-modulo__seta acoes-modulo__seta--proxima acoes-modulo__seta--abas",
                        attrs: {
                          type: "button",
                          disabled: _vm.noFimAbas,
                          "aria-label": "Ver mais módulos"
                        },
                        on: {
                          click: function($event) {
                            return _vm.rolarAbas(1)
                          }
                        }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "arrow-down-light",
                            size: 13,
                            color: "currentColor"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "acoes-modulo-troca", mode: "out-in" } },
            [
              _vm.ehLista
                ? _c(
                    "div",
                    {
                      key: "lista-" + _vm.chaveDoModuloAtivo,
                      staticClass: "acoes-modulo__lista"
                    },
                    [
                      _vm._l(_vm.acoesVisiveisNaLista, function(acao) {
                        return _c(
                          "button",
                          {
                            key: acao.id,
                            ref: "acoes",
                            refInFor: true,
                            staticClass: "acoes-modulo__linha",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.usar(acao)
                              },
                              keydown: _vm.aoTeclarNaAcao
                            }
                          },
                          [
                            _c("icon-svg", {
                              staticClass: "acoes-modulo__linha-icone",
                              attrs: {
                                name: acao.icone,
                                size: _vm.tamanhoDoIconeDaLinha,
                                color: "currentColor"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "acoes-modulo__linha-titulo ia-texto-corpo"
                              },
                              [_vm._v(_vm._s(acao.titulo))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "acoes-modulo__linha-descricao ia-texto-auxiliar"
                              },
                              [_vm._v(_vm._s(acao.descricao))]
                            )
                          ],
                          1
                        )
                      }),
                      _vm.temMaisAcoesNaLista
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "acoes-modulo__mostrar-mais ia-texto-auxiliar",
                              attrs: { type: "button" },
                              on: { click: _vm.expandirListaDeAcoes }
                            },
                            [
                              _vm._v(
                                " Mostrar mais " +
                                  _vm._s(
                                    _vm.quantidadeDeAcoesRestantesNaLista
                                  ) +
                                  " sugestões "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _c(
                    "div",
                    {
                      key: "grade-" + _vm.chaveDoModuloAtivo,
                      ref: "trilho",
                      staticClass: "acoes-modulo__grade",
                      on: { scroll: _vm.aoRolar }
                    },
                    _vm._l(_vm.acoesDaAba, function(acao) {
                      return _c(
                        "button",
                        {
                          key: acao.id,
                          ref: "acoes",
                          refInFor: true,
                          staticClass: "acoes-modulo__cartao",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.usar(acao)
                            },
                            keydown: _vm.aoTeclarNaAcao
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "acoes-modulo__icone" },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: acao.icone,
                                  size: _vm.tamanhoDoIcone,
                                  color: "currentColor"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "acoes-modulo__titulo ia-texto-corpo"
                            },
                            [_vm._v(_vm._s(acao.titulo))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "acoes-modulo__descricao ia-texto-auxiliar"
                            },
                            [_vm._v(_vm._s(acao.descricao))]
                          )
                        ]
                      )
                    }),
                    0
                  )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }